import React, { useEffect, useRef, useState } from 'react';
import { Nodes } from './interactiveNodes.js';
import Container from "react-bootstrap/Container";
import styles from './interactive-buttons.module.scss'
import { useGazeData } from '../../hooks/useGazeData.js';

const DefaultRegionMargin = 18;

const InteractiveNodesCanvas = () => {
    const canvasRef = useRef(null);
    const [selectedImage, setSelectedImage] = useState('01');

    // Get mode from query parameter
    const getMode = () => {
        const params = new URLSearchParams(window.location.search);
        return params.get('simulategaze') === null && window.eyeTracking ? 'gaze' : 'mouse';
    };

    // Image options for radio buttons
    const imageOptions = [
        { id: '01', title: '01 - Batman' },
        { id: '02', title: '02 - Cook' },
        { id: '03', title: '03 - Ewok' },
        { id: '04', title: '04 - Yoda' }
    ];

    // Load selected image
    const loadSelectedImage = (imageId) => {
        const imagePath = `/interactive-nodes-assets/${imageId}.png`;
        if (window.Nodes) {
            // Clean up before loading new image
            Nodes.destroy();
            Nodes.loadData(imagePath);
        }
    };

    // Handle radio button change
    const handleImageSelection = (imageId) => {
        setSelectedImage(imageId);
        loadSelectedImage(imageId);
    };

    useEffect(() => {
        // Load default image when component mounts
        if (canvasRef.current) {
            loadSelectedImage(selectedImage);
        }
    }, [selectedImage]);

    const mode = getMode();

    useGazeData(({ x, y }) => {
        if (window.Nodes) {

            window.Nodes.mouse.x = x - Nodes.canvas.offsetLeft;
            window.Nodes.mouse.y = y - Nodes.canvas.offsetTop;
        }
    }, mode !== 'mouse');

    useEffect(() => {
        if (!canvasRef.current) return;

        const canvas = canvasRef.current;
        Nodes.init(canvas);

        loadSelectedImage("01"); // Load default image


        // Set up gaze handling after script loads
        if (mode === 'mouse') {
            canvas.addEventListener('mousemove', handleMouseMove, false);
            canvas.addEventListener('mouseout', mouseOut, false);
        }

        return () => {
            // Clean up Nodes resources
            if (window.Nodes) {
                window.Nodes.destroy();
            }

            if (mode === 'mouse') {
                canvas.removeEventListener('mousemove', handleMouseMove, false);
                canvas.removeEventListener('mouseout', mouseOut, false);
            }
        };
    }, [mode]);

    const handleMouseMove = (event) => {
        if (window.Nodes) {
            Nodes.mouse.x = event.offsetX || (event.layerX - Nodes.canvas.offsetLeft);
            Nodes.mouse.y = event.offsetY || (event.layerY - Nodes.canvas.offsetTop);
        }
    };

    const mouseOut = (event) => {
        if (window.Nodes) {
            Nodes.mouse.x = -1000;
            Nodes.mouse.y = -1000;
            Nodes.mouse.down = false;
        }
    };

    return (
        <div style={{
            position: 'relative',
            width: '100vw',
            height: 'calc(100vh - 56px)', // Subtract navbar height
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden'
        }}>
            {/* Radio buttons panel */}
            <div style={{
                position: 'absolute',
                left: '20px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: '15px',
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: '20px',
                borderRadius: '8px',
                color: 'white'
            }}>
                <h3 style={{ margin: '0 0 10px 0', fontSize: '16px', fontWeight: 'bold' }}>
                    Select Image:
                </h3>
                {imageOptions.map((option) => (
                    <label key={option.id} style={{
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontSize: '14px'
                    }}>
                        <input
                            type="radio"
                            name="imageSelection"
                            value={option.id}
                            checked={selectedImage === option.id}
                            onChange={() => handleImageSelection(option.id)}
                            style={{
                                marginRight: '8px',
                                transform: 'scale(1.2)'
                            }}
                        />
                        {option.title}
                    </label>
                ))}
            </div>
            <canvas
                ref={canvasRef}
                id="canvas"
                onContextMenu={(e) => e.preventDefault()}
                tabIndex={-1}
                style={{
                    display: 'block'
                }}
            />
            <Container className={`${styles.buttonContainer} pt-4 pb-4 pl-4`}>
                <a is="a-gazable"
                    href="/"
                    dwell-animation="ltr"
                    data-gaze-region-margin={DefaultRegionMargin}
                    class="btn btn-primary btn-lg"
                >Back to Examples</a>
            </Container>
        </div>

    );
};

export default InteractiveNodesCanvas;